import { useState } from 'react';

function useOpenKakao() {
  const [isOpenKakao, setIsOpenKakao] = useState(false);

  return { isOpenKakao, setIsOpenKakao };
}

export default useOpenKakao;
